import { IntlShape } from 'react-intl'
import { create, enforce, group, omitWhen, test } from 'vest'
import { MoreForLessEffect } from '../../../../../../typings'
import { messages } from '../messages'

export function triggerValidationSuite(intl: IntlShape, name = '') {
  return create(
    ({
      trigger: { minQuantity, collections, skus },
    }: NonNullableObject<MoreForLessEffect>) => {
      const { $t } = intl
      const { validation } = messages.trigger

      group('trigger', () => {
        test(
          `${name}.minQuantity`,
          $t(validation.greaterThan, { value: 0 }),
          () => {
            enforce(minQuantity).isPositive()
          }
        )

        omitWhen(collections.length > 0 || skus.length > 0, () => {
          test(`${name}.skus`, $t(validation.required), () => {
            enforce(skus.length).gt(0)
          })

          test(`${name}.collections`, $t(validation.required), () => {
            enforce(collections.length).gt(0)
          })
        })
      })
    }
  )
}
